interface RenderHtmlProps {
    className?: string;
    tag?: string;
    children?: any;
    style?: any;
    markup?: any;

}

const defaultProps: RenderHtmlProps = {};

const RenderHtml = ({ children, className, style, markup, tag }: RenderHtmlProps) => {
    const css = ["html", "render-html"];

    if (className) {
        css.push(className);
    }

    return (
        <>
            {markup && <div
                className={css.join(" ")}
                style={style}
                dangerouslySetInnerHTML={{
                    __html: markup,
                }}
            >
            </div>}

            {children && <div
                className={css.join(" ")}
                style={style}
                dangerouslySetInnerHTML={{
                    __html: children,
                }}
            >
            </div>}
        </>
    );
};

RenderHtml.defaultProps = defaultProps;

export default RenderHtml;
